import Service from "../Service";
import { setUserInfo } from "./auth";

export const fetchUserInfo = () => async (dispatch) => {
    try {
        const service = new Service();
        const userInfo = await service.UserService.getUserInfo();
        
        if (userInfo) {
            dispatch(setUserInfo(userInfo));
        }
    } catch (error) {
        console.error('User info fetch error:', error);
        dispatch(setUserInfo({ is_read_only: 0 }));
    }
};

export const checkUserInfo = () => async (dispatch, getState) => {
    const { user } = getState().auth;
    
    if (user) {
        dispatch(fetchUserInfo());
    }
}; 